import StatesMap from '@components/StatesMap';
import WorldMap from '@components/WorldMap';
import { Link } from 'gatsby';
import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

const HomeMap = ({
  mapButtonLink,
  mapExternalLink,
  mapButtonText,
  mapsSubtitle,
  mapsTitle,
  countries,
  states,
  students,
  teachers,
}) => {
  const settings = {
    dots: false,
    lazyLoad: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const [showWorldMap, setShowWorldMap] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowWorldMap(true);
    }, 1000);

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  return (
    <div className='home-map-wrap slick-slider-arrow lt-rt-arrow'>
      <div className='container'>
        <div className='row map-head-row'>
          <div className='col-md-6'>
            <h2 className='heading-level-2 blue-color'>{mapsTitle} </h2>
          </div>
          <div className='col-md-6'>
            <p>
              <strong>{mapsSubtitle}</strong>
            </p>
          </div>
        </div>
        <div className='row map-head-row-1'>
          <div className='col-md-12'>
            <div className='row'>
              <div className='col-md-4'>
                <div className='counting-number-text blue-color'>
                  {' '}
                  {students}{' '}
                </div>
                <p className='text-uppercase'>students</p>
              </div>
              <div className='col-md-4'>
                <div className='counting-number-text green-color'>
                  {' '}
                  {teachers}{' '}
                </div>
                <p className='text-uppercase'>Teachers</p>
              </div>
              <div className='col-md-4'>
                <div className='row counting-btm-row'>
                  <div className='col-4'>
                    <div className='counting-number-text pink-color'>
                      {' '}
                      {states}{' '}
                    </div>
                    <p className='text-uppercase'>U.S. states</p>
                  </div>
                  <div className='col-4'>
                    <p className='text-uppercase'>AND</p>
                  </div>
                  <div className='col-4'>
                    <div className='counting-number-text dark-green-color'>
                      {' '}
                      {countries}{' '}
                    </div>
                    <p className='text-uppercase'>countries</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-12 h-map-sec'>
            <Slider {...settings}>
              <div>
                <StatesMap />
                <div className='map-btminfo-col'>
                  <div>
                    <div className='map-info-title'>States Reached</div>
                    <div className='map-info-sub-title'>*Including D.C. and Puerto Rico</div>
                  </div>
                </div>
              </div>
              {showWorldMap && (
                <div>
                  <WorldMap />
                </div>
              )}
            </Slider>
          </div>
        </div>
      </div>

      <div className='container'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='map-btn-sec text-center'>
              {mapExternalLink ? (
                <a href={mapExternalLink} className="btn blue-btn">
                  {mapButtonText}
                </a>
              ) : mapButtonLink ? (
                <Link to={mapButtonLink.uri} className='btn blue-btn'>
                  {mapButtonText}
                </Link>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeMap;
